import { FaLinkedin } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const linkedinBaseSettings: SocialPlatformBaseSettings = {
  name: "LinkedIn",
  icon: FaLinkedin,
  fields: {
    caption: "optional",
    altText: "optional",
    linkAttachment: "optional",
    polls: "optional",
    userTags: "optional",
    // Technically supports document uploads - handle separately?
  },
  limits: {
    caption: 3000,
    images: 9,
    videos: 1,
    videoDurationSeconds: 10 * 60,
    pollOptions: 4,
  },
  notes: [
    "Ideal status update length: ~100 characters.",
    "Supports document uploads.",
  ],
  postTypes: {
    post: {}, // Standard update
    article: {
      // Articles are different, much longer form
      nameSuffix: " Article",
      fields: { title: "required", caption: "required" }, // Articles require title and body
      limits: {
        caption: 120000,
        images: undefined,
        videos: undefined,
        polls: "not_allowed",
        linkAttachment: "not_allowed",
      },
      notes: ["LinkedIn Articles are long-form content."],
    },
  },
};
